// extracted by mini-css-extract-plugin
export var alternate = "_1q-j";
export var black = "_1q-6";
export var blue = "_1q-f";
export var blueLight = "_1q-e";
export var brand = "_1q-8";
export var darkMode = "_1q-b";
export var error = "_1q-a";
export var gray = "_1q-5";
export var grayBlue = "_1q-d";
export var iconWrapper = "_1q-3";
export var inactive = "_1q-7";
export var indigo = "_1q-g";
export var orange = "_1q-i";
export var pink = "_1q-h";
export var primary = "_1q-0";
export var purple = "_1q-9";
export var success = "_1q-4";
export var warning = "_1q-c";
export var white = "_1q-1";
export var whiteSuccess = "_1q-2";